import React from 'react';
import { CheckIcon } from 'lucide-react';
import { BENEFITS, IMAGES } from '../data/site';
export function BenefitsSection() {
  return <section className="bg-steel-50 py-10 sm:py-16" data-id="element-11" data-mp="bpdgowstisq">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-6 px-4 sm:px-6 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:items-center lg:gap-14" data-id="element-12" data-mp="3iqq47i2ki8so">
        <img src={IMAGES.ligero} alt="Una sola persona sostiene sin esfuerzo una bovedilla EPS de 300 cm" className="aspect-[4/3] w-full rounded-xl object-cover object-[50%_40%] lg:aspect-[4/5] lg:object-center" loading="lazy" data-id="element-13" data-mp="3nngh5wj2so9v" />
        <div data-id="element-14" data-mp="2zsnjhfh1yy0o">
          <h2 className="font-display text-[1.75rem] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-15" data-mp="2zt6t88wjug3m">
            Por qué los constructores eligen EPS para su losa
          </h2>
          <ul className="mt-5 grid gap-x-6 gap-y-4 sm:grid-cols-2" data-id="element-16" data-mp="y1ai30ean89d">
            {BENEFITS.map(benefit => <li key={benefit.title} className="flex gap-3" data-id="element-17" data-mp="12yk74exrthwo">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-signal-600" aria-hidden="true" data-id="element-18" data-mp="2bee2fo1y62fp" />
                <div data-id="element-19" data-mp="27edmfyz79j6j">
                  <h3 className="text-[15px] font-semibold text-navy-900" data-id="element-20" data-mp="27cspy3tbrq61">{benefit.title}</h3>
                  <p className="text-sm text-steel-600" data-id="element-21" data-mp="2l3nuj3wsjl3t">{benefit.text}</p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}